import { render, staticRenderFns } from "./DetectionFilterLink.vue?vue&type=template&id=1225c958&scoped=true"
import script from "./DetectionFilterLink.vue?vue&type=script&lang=js"
export * from "./DetectionFilterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1225c958",
  null
  
)

export default component.exports